<template>
    <div class="exhibitor-registration-component">
        <h1 v-if="!toAnchor">
            {{ !allReadOnly ? translations.title : translations.titleValidated }}
        </h1>
        <h1 v-else>
            {{ toAnchor === 'validated' ? translations.titleValidated : translations.titleWithAnchor }}
        </h1>
        <h2 class="with-deco">
            {{ translations.categoryTitle }}
        </h2>

        <div class="categories">
            <div
                v-for="category in categories"
                :key="category.id"
                class="category-item-container"
            >
                <!-- <a
                    v-if="category.extra_attributes.redirect_other_route"
                    :class="`block no-underline category-item ${category.id === selectedCategoryId ? 'is-selected' : ''}
                        ${hasId ? 'read-only' : ''}`"
                    :href="!hasId ? otherRoute : null"
                >
                    {{ category.title }}
                </a> -->
                <div
                    :class="`category-item ${category.id === selectedCategoryId ? 'is-selected' : ''}
                        ${hasId ? 'read-only' : ''}`"
                    @click="selectCategory(category.id)"
                >
                    {{ category.title }}
                </div>
            </div>
        </div>
        <div id="form">
            <form
                ref="form"
                v-if="selectedCategoryId"
                @submit="(e) => sumbitForm(e)"
                enctype="multipart/form-data"
            >
                <h2 class="with-deco">
                    {{ translations.exhibitorFormTitle }}
                </h2>
                <div
                    v-if="selectedCategoryId === showWarningFor"
                    ref="checkboxesLoginForm"
                >
                    <div class="warning">
                        {{ translations.warningMessage }}
                    </div>

                    <div class="create-exhibitor-form login-form">
                        <div class="my-4 form-group form-group-radio">
                            <label :for="'list-status-1'">
                                <input
                                    type="radio"
                                    id="list-status-1"
                                    :value="1"
                                    v-model="exhibitor.listStatus"
                                    :disabled="allReadOnly"
                                >
                                <span
                                    :class="`checkmark checkbox ${newlyCreated && exhibitor.listStatus === null ? 'highlighted' : ''}`"
                                />
                                {{ translations.formLabels.listStatus1 }}
                            </label>
                        </div>

                        <div
                            v-if="exhibitor.listStatus === 1"
                            class="upload-form classification-upload"
                        >
                            <label
                                for="classification"
                                :class="`${newlyCreated
                                    && exhibitor.listStatus === 1
                                    && (!existing || !existing.classification) ? 'highlighted' : ''}`"
                            >
                                {{ translations.formLabels.uploadClassification }}
                            </label>
                            <div
                                v-if="(existing && existing.classification) && !showUpload.includes('classification') "
                            >
                                <div class="existing-actions">
                                    <div
                                        @click="download(existing.classification)"
                                        class="button mr-2"
                                    >
                                        {{ translations.formLabels.download }}
                                    </div>
                                    <div
                                        v-if="!allReadOnly"
                                        @click="toggleShowUpload('classification')"
                                        class="button"
                                    >
                                        {{ translations.formLabels.updateDocument }}
                                    </div>
                                </div>

                                <!-- <div
                                    v-if="exhibitor.conformityValidity"
                                    class="warning-validity"
                                >
                                    {{ translations.formLabels.conformityValid }}{{ exhibitor.conformityValidity }}.
                                </div> -->
                            </div>

                            <div
                                v-if="!(existing && existing.classification) || showUpload.includes('classification')"
                            >
                                <div class="input-container">
                                    <input
                                        type="file"
                                        id="classification"
                                        name="upload_form_classification"
                                        accept=".jpg, .pdf"
                                        :required="newlyCreated"
                                        @change="addFilesUpload('upload_form_classification', classificationUploadId, 'classificationPath')"
                                    >
                                </div>

                                <div class="actions flex items-center">
                                    <div
                                        class="cancel"
                                        v-if="(existing && existing.classification) && showUpload.includes('classification')"
                                        @click="toggleShowUpload('classification', true)"
                                    >
                                        {{ translations.formLabels.cancelUpdateDocument }}
                                    </div>
                                </div>
                            </div>

                            <div
                                class="mb-4"
                                v-if="showUploadOk.includes('classificationPath')"
                            >
                                Fichier téléchargé. N'oubliez pas de valider.
                            </div>
                        </div>
                        <!-- <div
                            v-if="exhibitor.conformityValidity && existing?.classification && exhibitor.isValidated && !isConformityValid"
                            class="warning-validity is-not-valid"
                        >
                            {{ translations.formLabels.conformityNotValid }}{{ exhibitor.conformityValidity }}.
                        </div> -->

                        <div class="my-4 form-group form-group-radio">
                            <label :for="'list-status-3'">
                                <input
                                    type="radio"
                                    id="list-status-3"
                                    :value="3"
                                    v-model="exhibitor.listStatus"
                                    :disabled="allReadOnly"
                                >
                                <span
                                    :class="`checkmark checkbox ${newlyCreated && exhibitor.listStatus === null ? 'highlighted' : ''}`"
                                />
                                {{ translations.formLabels.listStatus3 }}
                            </label>
                        </div>

                        <div class="my-4 form-group form-group-radio">
                            <label :for="'list-status-2'">
                                <input
                                    type="radio"
                                    id="list-status-2"
                                    :value="2"
                                    v-model="exhibitor.listStatus"
                                    :disabled="allReadOnly"
                                >
                                <span
                                    :class="`checkmark checkbox ${newlyCreated && exhibitor.listStatus === null ? 'highlighted' : ''}`"
                                />
                                {{ translations.formLabels.listStatus2 }}
                                <!-- <div>
                                    <span>{{ translations.formLabels.listStatus2Info }}</span>
                                    <ul>
                                        <li>{{ translations.formLabels.listStatus2Info1 }}</li>
                                        <li>{{ translations.formLabels.listStatus2Info2 }}</li>
                                        <li>{{ translations.formLabels.listStatus2Info3 }}</li>
                                    </ul>
                                </div> -->
                            </label>
                        </div>
                    </div>
                </div>

                <div
                    class="create-exhibitor-form login-form"
                    ref="mainLoginForm"
                >
                    <div :class="`form-group ${errorsFields.includes('title') ? 'error' : ''}`">
                        <label class="control-label">{{ translations.formLabels.name }}*</label>
                        <input
                            class="form-control"
                            v-model="exhibitor.title"
                            :disabled="hasId"
                            @keyup="checkKeyForm('title', exhibitor.title)"
                        >
                    </div>

                    <div :class="`form-group ${errorsFields.includes('zipcode') ? 'error' : ''}`">
                        <label class="control-label">{{ translations.formLabels.zipcode }}*</label>
                        <input
                            class="form-control js-zipcode"
                            v-model="exhibitor.zipcode"
                            :disabled="hasId"
                            @keyup="checkKeyForm('zipcode', exhibitor.zipcode)"
                        >
                    </div>

                    <div :class="`form-group ${errorsFields.includes('city') ? 'error' : ''}`">
                        <label class="control-label">{{ translations.formLabels.city }}*</label>
                        <!-- <input
                            class="form-control"
                            v-model="exhibitor.city"
                            :disabled="hasId"
                            @keyup="checkKeyForm('city', exhibitor.city)"
                        > -->
                        <select
                            v-if="!exhibitor.city"
                            class="form-control"
                            v-model="exhibitor.city"
                            :disabled="hasId"
                            @change="checkKeyForm('city', exhibitor.city)"
                        >
                            <option
                                v-for="(city, index) in cities"
                                :key="index"
                                :value="city.nom"
                            >
                                {{ city.nom }}
                            </option>
                        </select>
                        <input
                            v-else
                            class="form-control js-zipcode"
                            v-model="exhibitor.city"
                            :disabled="hasId && exhibitor.city"
                        >
                    </div>

                    <div :class="`form-group ${errorsFields.includes('selectedPriceGroupId') ? 'error' : ''}`">
                        <label class="control-label">{{ translations.formLabels.selectedPriceGroup }}*</label>
                        <select
                            class="form-control"
                            v-model="selectedPriceGroupId"
                            :disabled="hasId"
                            @change="checkKeyForm('selectedPriceGroupId', selectedPriceGroupId)"
                        >
                            <option value="" />
                            <option
                                v-for="priceGroup in priceGroupsToShow"
                                :key="priceGroup.id"
                                :value="priceGroup.id"
                            >
                                {{ priceGroup.title }}
                            </option>
                        </select>
                    </div>

                    <div
                        v-if="selectedPriceGroupId && selectedPriceGroupId === showVariationsFor"
                    >
                        <div :class="`form-group ${errorsFields.includes('selectedVariationId') ? 'error' : ''}`">
                            <label class="control-label">{{ translations.formLabels.selectedVariation }}*</label>
                            <select
                                class="form-control"
                                v-model="selectedVariationId"
                                :disabled="hasId"
                                @change="checkKeyForm('selectedVariationId', selectedVariationId)"
                            >
                                <option value="" />
                                <option
                                    v-for="variation in variationOptions"
                                    :key="variation.id"
                                    :value="variation.id"
                                >
                                    {{ variation.description }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div v-if="newlyCreated">
                        <div class="newly-created-info">
                            {{ translations.formLabels.newlyCreatedInfo }}
                        </div>

                        <div class="upload-form">
                            <label for="kbis">{{ translations.formLabels.uploadKbis }}</label>
                            <div
                                v-if="(existing && existing.kbis) && !showUpload.includes('kbis') "
                                class="existing-actions"
                            >
                                <div
                                    @click="download(existing.kbis)"
                                    class="button mr-2"
                                >
                                    {{ translations.formLabels.download }}
                                </div>
                                <div
                                    v-if="!allReadOnly"
                                    @click="toggleShowUpload('kbis')"
                                    class="button"
                                >
                                    {{ translations.formLabels.updateDocument }}
                                </div>
                            </div>

                            <div
                                v-if="!(existing && existing.kbis) || showUpload.includes('kbis')"
                            >
                                <div class="input-container">
                                    <input
                                        type="file"
                                        id="kbis"
                                        name="upload_form_kbis"
                                        required
                                        accept=".jpg, .pdf"
                                        @change="addFilesUpload('upload_form_kbis', kbisUploadId, 'kbisPath')"
                                    >
                                </div>

                                <div class="actions flex items-center">
                                    <!-- <button
                                    type="submit"
                                    class="button"
                                >
                                    {{ translations.formLabels.uploadSubmit }}
                                </button> -->
                                    <div
                                        class="cancel"
                                        v-if="(existing && existing.kbis) && showUpload.includes('kbis')"
                                        @click="toggleShowUpload('kbis', true)"
                                    >
                                        {{ translations.formLabels.cancelUpdateDocument }}
                                    </div>
                                </div>
                            </div>

                            <div
                                class="mb-4"
                                v-if="showUploadOk.includes('kbisPath')"
                            >
                                Fichier téléchargé. N'oubliez pas de valider.
                            </div>
                        </div>

                        <div class="upload-form">
                            <label for="insurance">{{ translations.formLabels.uploadInsurance }}</label>
                            <div
                                v-if="(existing && existing.insurance) && !showUpload.includes('insurance')"
                                class="existing-actions"
                            >
                                <div
                                    @click="download(existing.insurance)"
                                    class="button mr-2"
                                >
                                    {{ translations.formLabels.download }}
                                </div>
                                <div
                                    v-if="!allReadOnly"
                                    @click="toggleShowUpload('insurance')"
                                    class="button"
                                >
                                    {{ translations.formLabels.updateDocument }}
                                </div>
                            </div>
                            <div
                                v-if="!(existing && existing.insurance) || showUpload.includes('insurance')"
                            >
                                <div class="input-container">
                                    <input
                                        type="file"
                                        id="insurance"
                                        required
                                        class="form-control"
                                        name="upload_form_insurance"
                                        accept=".jpg, .pdf"
                                        @change="addFilesUpload('upload_form_insurance', insuranceUploadId, 'insurancePath')"
                                    >
                                </div>

                                <div class="actions flex items-center">
                                    <!-- <button
                                    type="submit"
                                    class="button"
                                >
                                    {{ translations.formLabels.uploadSubmit }}
                                </button> -->
                                    <div
                                        class="cancel"
                                        v-if="(existing && existing.insurance) && showUpload.includes('insurance')"
                                        @click="toggleShowUpload('insurance', true)"
                                    >
                                        {{ translations.formLabels.cancelUpdateDocument }}
                                    </div>
                                </div>
                            </div>
                            <div v-if="showUploadOk.includes('insurancePath')">
                                Fichier téléchargé. N'oubliez pas de valider.
                            </div>
                        </div>
                    </div>

                    <div
                        v-else
                        class="my-4 form-group form-group-checkbox"
                    >
                        <label for="is-up-to-date">
                            <input
                                type="checkbox"
                                id="is-up-to-date"
                                v-model="exhibitor.isUpToDate"
                                required
                                :disabled="allReadOnly"
                            >
                            <span :class="`checkmark checkbox ${!exhibitor.isUpToDate ? 'highlighted' : ''}`" />

                            {{ translations.formLabels.isUpToDate }}
                        </label>
                    </div>
                    <button
                        v-if="!allReadOnly"
                        class="mt-8 button"
                        type="submit"
                        :disabled="disabledButton"
                    >
                        {{ translations.formLabels.formSubmit }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'ExhibitorRegistration',
    props: {
        existing: { type: Object, default: () => ({}) },
        translations: { type: Object, required: true },
        categories: { type: Array, required: true },
        priceGroups: { type: Array, required: true },
        variationOptions: { type: Array, required: true },
        showVariationsFor: { type: Number, required: true },
        showWarningFor: { type: Number, required: true },
        route: { type: String, required: true },
        uploadRoute: { type: String, required: true },
        downloadRoute: { type: String, required: true },
        kbisUploadId: { type: Number, required: true },
        insuranceUploadId: { type: Number, required: true },
        classificationUploadId: { type: Number, required: true },
        otherRoute: { type: String, required: false, default: null },
        toAnchor: { type: String, required: false, default: null },
        // isConformityValid: { type: Boolean, required: false, default: false },
    },
    components: {
    },
    data() {
        return {
            selectedCategoryId: null,
            selectedPriceGroupId: null,
            selectedVariationId: null,
            newlyCreated: true,
            exhibitor: {
                id: null,
                title: '',
                city: '',
                zipcode: '',
                listStatus: null,
                isUpToDate: false,
                isValidated: null,
                // conformityValidity: null,
            },
            kbisPath: null,
            insurancePath: null,
            classificationPath: null,
            showUpload: [],
            showUploadOk: [],
            errorsFields: [],
            filesUpload: [],
            listCities: [],
        };
    },
    computed: {
        priceGroupsToShow() {
            if (this.selectedCategoryId) {
                return this.priceGroups.filter((el) => el.extra_attributes?.exhibitor_category === this.selectedCategoryId);
            }
            return null;
        },
        disabledButton() {
            if (this.selectedCategoryId && this.selectedPriceGroupId) {
                if (this.selectedCategoryId === this.showWarningFor) {
                    if (this.selectedPriceGroupId === this.showVariationsFor) {
                        if (!this.exhibitor.listStatus) {
                            return true;
                        }
                        return !this.selectedVariationId;
                    }
                    return !this.exhibitor.listStatus;
                }
                return false;
            }
            return true;
        },
        hasId() {
            return this.exhibitor.id !== null;
        },
        cities() {
            if (!this.exhibitor.zipcode) {
                return [];
            }
            return this.listCities.filter((item) => item.codesPostaux.includes(this.exhibitor.zipcode));
        },
        allReadOnly() {
            const isValidated = this.existing?.extra_attributes?.isValidated;
            const isNew = this.newlyCreated;
            const isWarningCategory = this.selectedCategoryId === this.showWarningFor;
            if (!isValidated) {
                return false;
            }
            if (isNew) {
                if (isWarningCategory) {
                    return this.existing?.kbis && this.existing?.insurance && this.existing?.classification;
                }
                return this.existing?.kbis && this.existing?.insurance;
            }
            if (isWarningCategory) {
                // return this.existing?.extra_attributes?.isUpToDate && this.existing?.classification && this.isConformityValid;
                return this.existing?.extra_attributes?.isUpToDate && this.existing?.classification;
            }
            return this.existing?.extra_attributes?.isUpToDate;
        },
    },
    mounted() {
        axios.get('https://geo.api.gouv.fr/communes').then((res) => {
            this.listCities = res.data;
        });
        if (this.existing) {
            this.selectedCategoryId = this.existing.category_id;
            this.selectedPriceGroupId = parseInt(this.existing.selectedPriceGroupId, 10);
            this.newlyCreated = this.existing.extra_attributes.newlyCreated;
            this.exhibitor = {
                id: this.existing.id,
                title: this.existing.title,
                city: this.existing.city,
                zipcode: this.existing.zipcode,
                listStatus: this.existing.extra_attributes?.listStatus,
                isUpToDate: this.existing.extra_attributes?.isUpToDate,
                isValidated: this.existing.extra_attributes.isValidated,
                // conformityValidity: this.existing.extra_attributes?.conformityValidity,
            };
            if (parseInt(this.existing.selectedPriceGroupId, 10) === this.showVariationsFor) {
                this.selectedVariationId = this.existing.extra_attributes?.selectedVariation;
            }
        }
        this.$nextTick(() => {
            if (this.toAnchor && this.$refs[`${this.toAnchor}LoginForm`]) {
                this.$refs[`${this.toAnchor}LoginForm`].scrollIntoView({ behavior: 'smooth' });
            }
        });
    },
    methods: {
        selectCategory(categoryId) {
            if (this.allReadOnly) {
                return;
            }
            if (!this.hasId) {
                this.selectedCategoryId = categoryId;
                this.$nextTick(() => {
                    document.querySelector('#form')?.scrollIntoView({ behavior: 'smooth' });
                });
            }
        },
        async sumbitForm(e) {
            e.preventDefault();
            this.errorsFields = [];
            const requiredExhibFields = ['title', 'city', 'zipcode'];
            requiredExhibFields.forEach((field) => {
                if (!this.exhibitor[field]) {
                    this.errorsFields.push(field);
                }
            });
            if (!this.selectedPriceGroupId) {
                this.errorsFields.push('selectedPriceGroupId');
            }
            if (!this.selectedVariationId) {
                this.errorsFields.push('selectedVariationId');
            }
            const promises = [];
            this.filesUpload.forEach((item) => {
                promises.push(this.upload(item).then((res) => {
                    this[item.dataPathKey] = res.data;
                }));
            });
            Promise.all(promises).then(() => {
                if (!this.disabledButton) {
                    const toSend = {
                        ...this.exhibitor,
                        categoryId: this.selectedCategoryId,
                        selectedPriceGroup: this.selectedPriceGroupId,
                        selectedVariation: this.selectedVariationId,
                        newlyCreated: this.newlyCreated ?? 0,
                        kbisPath: this.kbisPath,
                        insurancePath: this.insurancePath,
                        classificationPath: this.classificationPath,
                    };
                    axios.post(this.route, toSend).then((response) => {
                        if (response.data) {
                            window.location.href = response.data;
                        }
                    });
                }
            });
        },
        addFilesUpload(refKey, documentUploadId, dataPathKey) {
            const formData = new FormData(this.$refs.form);
            if (formData.get(refKey).name) {
                this.filesUpload.push({
                    refKey,
                    documentUploadId,
                    dataPathKey,
                });
            }
        },
        upload(item) {
            const { refKey, documentUploadId } = item;
            const formData = new FormData(this.$refs.form);
            const config = {
                params: { documentUploadId, refKey },
            };
            return axios.post(this.uploadRoute, formData, config);
        },
        resetForm() {
            this.$refs.upload_form.reset();
        },
        download(path) {
            axios.get(this.downloadRoute, {
                params: {
                    path,
                },
                responseType: 'blob',
            }).then((res) => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${res.headers.filename}.${res.headers.ext}`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            });
        },
        toggleShowUpload(key, cancel) {
            const index = this.showUpload.findIndex((el) => el === key);
            if (index === -1) {
                this.showUpload.push(key);
            } else if (cancel) {
                this.showUpload.splice(index, 1);
            }
        },
        checkKeyForm(key, value) {
            const indexError = this.errorsFields.indexOf(key);
            if (value && indexError > -1) {
                this.errorsFields.splice(indexError, 1);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.exhibitor-registration-component {
    h2 {
        @include pxtoRem(font-size, 40);
        @include pxtoRem(line-height, 50);
        &.with-deco::after {
            bottom: -24px;
        }
    }

    .categories {
        @include pxtoRem(margin-bottom, 25);
        @screen md {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-auto-rows: 1fr;
            @include pxtoRem(grid-gap, 16);
            @include pxtoRem(margin-bottom, 108);
        }

        .category-item-container {
            background-color: var(--secondary);
        }

        .category-item {
            width: 100%;
            min-height: 77px;
            height: 100%;
            color: var(--white);
            font-family: var(--fontHeadings);
            display: flex;
            align-items: center;
            font-weight: 700;
            text-transform: uppercase;
            cursor: pointer;
            transition: all .2s ease;
            @include pxtoRem(padding, 32);
            @include pxtoRem(font-size, 25);
            @include pxtoRem(line-height, 38);
            @screen md {
                min-height: 190px;
            }

            &:not(.read-only):hover, &.is-selected {
                background-color: var(--primary);
                color: var(--white);
            }

            &.read-only {
                cursor: unset;
            }
        }
    }

    .create-exhibitor-form {
        padding: 15px;
        @screen md {
            @include pxtoRem(padding-left, 70);
            @include pxtoRem(padding-right, 70);
            @include pxtoRem(padding-top, 58);
            @include pxtoRem(padding-bottom, 58);
        }

        .form-group-radio, .form-group-checkbox {
            position: relative;

            label {
                cursor: pointer;
                @include pxtoRem(margin-left, 32);
                @include pxtoRem(font-size, 17);
                @include pxtoRem(line-height, 22);
            }
            input[type="radio"], input[type="checkbox"] {
                position: absolute;
                opacity: 0;
                cursor: pointer;
                height: 1px;
                width: 1px;
            }

            .checkmark {
                position: absolute;
                top: 0;
                left: 0;
                height: 22px;
                width: 22px;
                border: 1px solid #D3E1EE;
                background-color: var(--white);

                &.highlighted {
                    border: 2px solid var(--red);
                }
            }

            .checkmark:after {
                content: "";
                position: absolute;
                display: none;
                width: 15px;
                height: 15px;
                background-color: var(--primary);
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            input[type="radio"]:checked ~ .checkmark:after,
            input[type="checkbox"]:checked ~ .checkmark:after {
                display: block;
            }

            input[type="radio"]:disabled ~ .checkmark,
            input[type="checkbox"]:disabled ~ .checkmark {
                border: 2px solid #cccccc;
                &:after {
                    background-color: #cccccc;
                }
            }
        }

        .newly-created-info {
            @include pxtoRem(margin-bottom, 23);
        }

        .upload-form {

            &.classification-upload {
                @include pxtoRem(margin-left, 32);
            }

            label {
                @include pxtoRem(font-size, 14);
                @include pxtoRem(line-height, 16);
                @include pxtoRem(margin-bottom, 8);

                &[for="classification"].highlighted {
                    color: var(--red);
                    font-weight: 700;
                }
            }

            .form-container {
                @include pxtoRem(margin-bottom, 16);
            }

            .input-container {
                background-color: var(--white);
                width: 100%;
                display: flex;
                align-items: center;
                @include pxtoRem(padding-left, 8);
                @include pxtoRem(min-height, 50);
            }

            .actions {
                @include pxtoRem(margin-left, 26);

                .cancel {
                    font-family: var(--fontHeadings);
                    cursor: pointer;
                    @include pxtoRem(margin-left, 8);
                }
            }

            .existing-actions {
                display: flex;
                @include pxtoRem(margin-bottom, 16);

                .button {
                    border: solid 1px var(--primary);
                    color: var(--primary);
                    background-color: unset;
                    @include pxtoRem(font-size, 14);
                    @include pxtoRem(line-height, 16);
                    @include pxtoRem(margin-top, 8);
                    &:hover {
                        background-color: var(--primary);
                        color: var(--white);
                    }
                }
            }
        }
    }

    .button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        &:hover {
            background-color: var(--primary);
            color: var(--white);
        }
    }

    .warning {
        background: $secondary;
        color: $white;
        padding: 10px;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .warning-validity {
        font-weight: bold;
        &.is-not-valid {
            color: $secondary;
        }
    }
}
</style>
